import { AdapterCommands } from './types'

import { start } from '@app/adapters/tutorial'

const availableAdapters = {
  tutorial: start,
}

const useAdapter = (command: AdapterCommands): void => {
  switch (command.type) {
    case 'tutorial':
      availableAdapters.tutorial(command.payload.tutorialId)
      break
    default:
      break
  }
}

export default useAdapter
